import {includes, map, without} from 'lodash';
import {useState} from 'react';

import './CategoryPicker.scss';

const defaultFilters = {
  PharmGKB: 'PharmGKB',
  CPIC: 'CPIC',
  guideline: 'CPIC Guidelines',
  PharmCAT: 'PharmCAT',
  PharmVar: 'PharmVar',
  'AMP PGxWG': 'AMP PGxWG',
  'ClinGen PGxIC': 'ClinGen PGxIC',
  pathway: 'Pathways',
  vip: 'VIPs',
  other: 'Other',
};

export default function CategoryPicker({initialKeys, onChange}) {
  const [selectedKeys, setSelectedKeys] = useState(initialKeys || []);
  const handleChange = (key) => () => {
    let newKeys;
    if (!includes(selectedKeys, key)) {
      newKeys = [...selectedKeys, key];
      setSelectedKeys(newKeys);
    } else {
      newKeys = without(selectedKeys, key);
      setSelectedKeys(newKeys);
    }
    onChange(newKeys);
  };

  return (
    <div className="pub-page-category">
      <h3>Category</h3>
      {map(Object.keys(defaultFilters), (key) => (
        <label key={key} style={{display: 'block'}} htmlFor={key}>
          <input type="checkbox" id={key} value={key} checked={includes(selectedKeys, key)} onChange={handleChange(key)} className="form-check-input" />
          {defaultFilters[key]}
        </label>
      ))}
    </div>
  );
}
